import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import YoutubeVideo from 'common/components/YoutubeVideo';

export default function bind() {
  const $videos = $('.video');
  $videos.each((index, element) => {
    const $element = $(element);

    const name = $element.attr('data-name');
    const title = $element.attr('data-title');
    const value = $element.attr('data-value');

    ReactDOM.render(
      <YoutubeVideo name={name} title={title} value={value} />,
      element
    );
  });
}



// WEBPACK FOOTER //
// ./src/plugins/youtube.js